import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { showAlert } from 'actions/common/alert';
import Completion from 'components/OrderAggregators/Completion';

const mapStateToProps = ({ orderAggregatorsCompletion }) => ({
  ...orderAggregatorsCompletion
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      showAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Completion);



// WEBPACK FOOTER //
// ./src/containers/OrderAggregators/Completion/index.js